import request from '../config/request';

const prefix = '/provider';

export const FetchProvidersAPI = async (params: any) => {
  const responseType = params.format ? 'blob' : undefined;
  const response = await request({
    url: prefix + '/list',
    method: 'GET',
    params,
    responseType,
  });

  return response;
};

export const AddProviderAPI = async (body: any) => {
  const response = await request({
    url: prefix + '/create-provider',
    method: 'POST',
    body,
  });

  return response;
};

export const AddBranchAPI = async (body: any) => {
  const response = await request({
    url: prefix + '/add-branch',
    method: 'POST',
    body,
  });

  return response;
};

export const FetchProviderHistoryApi = async (params: any) => {
  const response = await request({
    url: prefix + `/actionHistory/${params?.providerId}`,
    method: 'GET',
  });

  return response;
};

export const AddFreelancerProviderAPI = async (body: any) => {
  const response = await request({
    url: prefix + '/create-freelancer-provider',
    method: 'POST',
    body,
  });

  return response;
};

export const GetProviderProfileAPI = async (params: any) => {
  if (params.providerId) {
    const response = await request({
      // url: `${prefix}/${params.businessId}`,
      url: `${prefix}/${params.providerId}`,
    });

    return response;
  } else return null;
};
export const GetProviderCategoryAPI = async (params: any) => {
  if (params.providerId) {
    const response = await request({
      url: `${prefix}/category/${params.providerId}`,
    });

    return response;
  } else return null;
};

export const GetProviderSalonAPI = async (params: any) => {
  if (params.providerId) {
    const response = await request({
      // url: `/business-details/${params.businessId}`,
      url: `/business-details/${params.providerId}`,
    });

    return response;
  } else return null;
};

export const GetOperatingDays = async (body: any) => {
  const response = await request({
    url: prefix + `/update-provider/${body.id}`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'GET',
  });

  return response;
};

export const GetTimeSlotsForProviderCategory = async (providerCategoryId: any) => {
  const response = await request({
    url: prefix + `/time-slot/get?providerCategoryId=${providerCategoryId}`,
    method: 'GET',
  });
  return response;
};

export const UpdateTimeSlotsForProviderCategory = async (body: any) => {
  const response = await request({
    url: prefix + `/time-slot/manage`,
    method: 'POST',
    body,
  });
  return response;
};

export const AddCategoriesApi = async (body: any) => {
  const response = await request({
    url: prefix + `/add-sub-category`,
    method: 'POST',
    body,
  });
  return response;
};

export const AddProductApi = async (body: any) => {
  const payload =
    body && body.priceWithVat === undefined ? { ...body, priceWithVat: true } : body;
  const response = await request({
    url: prefix + `/add-product`,
    method: 'POST',
    body: payload,
  });
  return response;
};
export const UpdateProductApi = async (body: any) => {
  const payload =
    body && body.priceWithVat === undefined ? { ...body, priceWithVat: true } : body;
  const response = await request({
    url: prefix + `/update-product`,
    method: 'PUT',
    body: payload,
  });
  return response;
};

export const AddPackageApi = async (body: any) => {
  const response = await request({
    url: prefix + `/add-package`,
    method: 'POST',
    body,
  });
  return response;
};

export const UpdateProviderProfileAPI = async (body: any) => {
  const response = await request({
    url: prefix + `/update-provider/${body.id}`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'PUT',
    body,
  });

  return response;
};

export const ResendVerificationEmail = async (id: string) => {
  const response = await request({
    url: prefix + `/resend-email-verification-email/${id}`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'POST',
  });

  return response;
};

export const ToggleProviderActivationAPI = async (params: any) => {
  const response = await request({
    method: 'PUT',
    url: `${prefix}/toggle-provider-activation/${params.providerId}`,
  });

  return response;
};

export const ProviderPermissionAPI = async (body: any) => {
  const response = await request({
    method: 'PUT',
    url: `${prefix}/toggle-provider-permission/${body.id}`,
    body: body?.value,
  });

  return response;
};

export const ProviderChangeCommissionAPI = async (body: any) => {
  const response = await request({
    method: 'PUT',
    url: `${prefix}/change-commission`,
    body,
  });

  return response;
};

export const DeleteProviderApi = async (body: any) => {
  const response = await request({
    method: 'DELETE',
    url: `${prefix}/delete/${body.providerId}`,
    body,
  });

  return response;
};

export const GetProviderBookingProfileAPI = async (params: any) => {
  const response = await request({
    url: `${prefix}/booking/${params.providerId}`,
    params,
  });

  return response;
};
export const GetLoyaltyPointsListAPI = async (params: any) => {
  const response = await request({
    url: `/loyalty-point/${params.providerId}`,
    params,
  });

  return response;
};

export const GetBranchAnalyticsAPI = async (params: any) => {
  const { providerId, ...rest } = params;
  const responseType = rest.format ? 'blob' : undefined;
  const response = await request({
    url: `${prefix}/branch-analytics/${providerId}`,
    params: rest,
    responseType,
  });

  return response;
};

export const AddLoyaltyPointAPI = async (businessId: any, body: any) => {
  const response = await request({
    url: `/loyalty-point/${businessId}`,
    method: 'POST',
    body,
  });

  return response;
};

export const UpdateLoyaltyPointAPI = async (loyaltyPointId: any, body: any) => {
  const response = await request({
    url: `/loyalty-point/${loyaltyPointId}`,
    method: 'PUT',
    body,
  });

  return response;
};

export const DeleteLoyaltyPointAPI = async (body: any) => {
  const response = await request({
    method: 'DELETE',
    url: `/loyalty-point/${body.loyaltyPointId}`,
    body,
  });

  return response;
};

export const ProviderChangeBankDetailsAPI = async (body: any) => {
  const response = await request({
    method: 'PUT',
    url: `${prefix}/bank-details/${body.id}`,
    body,
  });

  return response;
};

export const InviteSalonOwner = async (body: any) => {
  const response = await request({
    url: prefix + `/invite-owner`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'POST',
    body,
  });

  return response;
};

export const OwnerRegistration = async (body: any) => {
  const response = await request({
    url: `/owner-registration/`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'POST',
    customURl: true,
    body,
  });

  return response;
};

export const SalonInfo = async (id: string) => {
  const response = await request({
    url: `/app/user/salon/${id}`,
    // url: prefix + `/update-provider/${body.providerId}`,
    method: 'GET',
    customURl: true,
  });

  return response;
};


export const UpdateProviderServices = async (body: any) => {

  const response = await request({
    url: prefix + '/update-services',
    method: 'PUT',
    body,
  });

  return response;
};



export const UpdateProviderProducts = async (body: any) => {
  const payload = {
    ...body,
    productsCategory: Array.isArray(body?.productsCategory)
      ? body.productsCategory.map((product: any) => ({
          ...product,
          priceWithVat: product?.priceWithVat ?? true,
        }))
      : body?.productsCategory,
  };
  const response = await request({
    url: prefix + '/update-products',
    method: 'PUT',
    body: payload,
  });

  return response;
};



export const UpdateProviderDetails= async (body: any) => {

  const response = await request({
    url: prefix + '/update-details',
    method: 'PUT',
    body,
  });

  return response;
};



export const UpdateProviderOperatingDays= async (body: any) => {

  const response = await request({
    url: prefix + '/update-operating-days',
    method: 'PUT',
    body,
  });

  return response;
};



export const UpdateProviderTimeSlots= async (body: any) => {

  const response = await request({
    url: prefix + '/update-time-slots',
    method: 'PUT',
    body,
  });

  return response;
};




export const UpdateProviderDeliveryOption= async (body: any) => {

  const response = await request({
    url: prefix + '/update-delivery-option',
    method: 'PUT',
    body,
  });

  return response;
};

export const UpdateProviderDeliveryRadius= async (body: any) => {

  const response = await request({
    url: prefix + '/update-delivery-radius',
    method: 'PUT',
    body,
  });

  return response;
};


export const UpdateProviderDeliveryAreas= async (body: any) => {

  const response = await request({
    url: '/business-delivery/add/'+body.id,
    method: 'POST',
    body,
  });

  return response;
};

export const SetProductActivationApi = async (body: { id: string; isActive: boolean }) => {
  const response = await request({
    url: `/products/set-activation/${body.id}`,
    method: 'PUT',
    body: { isActive: body.isActive },
  });

  return response;
};
